import UpdatePageFromUrl from "./updatepagefromurl.js";
import FilterMenu from "./filtermenu.js";
import UpdateFilterUrl from "./updatefilterurl.js";
import FilterValues from "./filtervalues.js";
import { prodListValues } from './shared.js';

const mobileFilterDropDown = document.getElementById('filterDropDown');

class EventListeners {
    constructor() {
        document.getElementById('filterDropDown').addEventListener('click', function (e) {
            e.preventDefault();

            if (this.classList.contains('active')) {
                this.parentElement.classList.remove('active');
                FilterMenu.unSelectMainMenu(this);
                if (document.querySelector(".openedFilter")) {
                    document.querySelector(".openedFilter").setAttribute("aria-expanded", "false");
                    document.querySelector(".openedFilter").classList.remove("openedFilter");
                }
                this.focus();
            } else {
                this.parentElement.classList.add('active');
                FilterMenu.selectMainMenu(this);
                FilterMenu.addTagFilters();
            }
        });

        document.getElementById('filterDropDown').addEventListener('keydown', function (e) {
            if (e.which === 9 && !e.shiftKey && this.classList.contains('active')) {
                e.preventDefault();

                var menu = document.getElementById('filterMenuMobile');

                if (menu.classList.contains('hide')) {
                    FilterMenu.openMenuOption.querySelector('.filterMenuSelect').focus();
                } else {
                    var listItems = document.getElementById('filterMenuMobile').querySelectorAll('li:not(.hide)');

                    if (listItems.length) {
                        listItems[0].children[0].focus();
                    }
                }
            }
        });

        document.getElementById('sortDropDown').addEventListener('change', function (e) {
            FilterMenu.setFilterOrder(this.value);
            UpdateFilterUrl.update(FilterValues, prodListValues, true);
        });

        document.getElementById('sortDropDown').addEventListener('click', function (e) {
            FilterMenu.unSelectMainMenu(document.getElementById(this.getAttribute('data-disable-id')));
        });

        document.getElementById('itemsPerPageDropDown').addEventListener('change', function (e) {
            FilterValues.addPageSize(this.value);
            FilterValues.addPageNumber(1);
            UpdateFilterUrl.update(FilterValues, prodListValues, true, true, true);
        });

        document.getElementById('toggleFilterSideBar').addEventListener('click', (e) => FilterMenu.toggleFilterOptions(e));

        const toggleTagFilters = document.getElementById('toggleTagFilters');
        toggleTagFilters && toggleTagFilters.addEventListener('click', (e) => FilterMenu.toggleTagFilters(e));

        window.onpopstate = function (event) {
            if (event.state !== null) {
                document.title = event.state.title;
                document.querySelector('meta[name="description"]').setAttribute('content', event.state.description);
            } else {
                document.title = '';
                document.querySelector('meta[name="description"]').setAttribute('content', '');
            }

            if (mobileFilterDropDown.classList.contains('active')) {
                FilterMenu.unSelectMainMenu(mobileFilterDropDown);
            }

            UpdatePageFromUrl.update();

            UpdateFilterUrl.update(FilterValues, prodListValues, true, false, true);
        };
    }

    pagerEvent() {
        Array.prototype.forEach.call(document.getElementsByClassName('pagerLink'), function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                var pageNo = this.getAttribute('data-page-number');

                if (!isNaN(pageNo)) {
                    document.getElementById('mainContent').scrollIntoView({ behavior: 'smooth' });
                    FilterValues.addPageNumber(pageNo);
                    UpdateFilterUrl.update(FilterValues, prodListValues, true);
                }
            });
        });
    };
}

export default new EventListeners();

/*const getBCInfo = function(el) {
    var productid = el.getAttribute('data-productid');
	
    if (!isNaN(productid)) {
        BetterChoicesDialog4i.BetterChoicesDialog(productid);
    }
};*/

/*const betterChoicesEvent = function () {
    const bcButtons = [].slice.call(document.querySelectorAll('.betterChoicesButton'));
    if(bcButtons.length > 0){
        let bcLogo = '<svg height="32px" width="102px" role="img" aria-label="Better Choices"><title>Better Choices</title> <use href="/icons/iconLibrary.svg#svgLogo-betterChoices"></use> </svg>';
        let dialogContent = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading better choices, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
    	
        let options = {
            triggerElements: bcButtons,
            dialogClass: "betterChoicesContent smallDialog", 
            title: bcLogo, 
            content: dialogContent, 
            onOpen: getBCInfo
        };
	
        betterChoicesModal.Init(options);
    }
};*/